import { render } from "./new-doc.vue?vue&type=template&id=2f6dc6a2"
import script from "./new-doc.vue?vue&type=script&lang=js"
export * from "./new-doc.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__